import { useLocation } from "react-router";
import { COMMUNICATION_ROOT_PATH } from "@/shared/configs/routes.config";

export const useCommunicationBackPath = (): string | undefined => {
  const location = useLocation();
  const prevPath: string | undefined = location.state?.prevPath;

  if (prevPath?.startsWith(COMMUNICATION_ROOT_PATH)) {
    return prevPath;
  }

  return undefined;
};
